import { NotificationConfiguration } from '../notification.templates';

export const MEETING_MINUTES_REVIEW_DUE_SOON_TEMPLATE: NotificationConfiguration = {
  inapp: `The review is pending until <b>{dueDate}</b>`,
  email: {
    ctaKey: 'review_now',
  },
};
